<div class="dialog-content-wrapper" style="margin: -24px;">
  <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{translations.lblAccessMappingForm}}</span>
          <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
    <table fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mat-table">
        <tbody class="mat-table" fxFlex="100">
          <tr class="mat-header-row">
            <th class="mat-header-cell cdk-column-position mat-column-page" style="widows: 20%;">Page Name</th>
            <th class="mat-header-cell cdk-column-position mat-column-view">Can View</th>
            <th class="mat-header-cell cdk-column-position mat-column-add">Can Add</th>
            <th class="mat-header-cell cdk-column-position mat-column-edit">Can Edit</th>
            <th class="mat-header-cell cdk-column-position mat-column-delete">Can Delete</th>
            <th class="mat-header-cell cdk-column-position mat-column-map">Can Map</th>
            <th class="mat-header-cell cdk-column-position mat-column-map">Can View Details</th>
          </tr>
          <tr *ngFor="let page of pageList" class="mat-row" >
            <td class="mat-cell cdk-column-position mat-column-page">
              {{page.Name}}
            </td>
    
            <td class="mat-cell cdk-column-position mat-column-page" fxLayoutAlign="space-between center">
              <mat-checkbox class="mat-can-view mat-checkbox mat-accent" aria-label="Can View" 
              [(ngModel)]="page.CanView" [disabled]="(page.CanCreate || page.CanUpdate || page.CanDelete || page.CanMap)"
                id="view-{{page.MenuId}}">
    
              </mat-checkbox>
            </td>
    
            <td class="mat-cell cdk-column-position mat-column-page" fxLayoutAlign="space-between center">
              <mat-checkbox class="mat-can-add" aria-label="Can Add" (change)="change($event,page)" 
              [(ngModel)]="page.CanCreate" id="add-{{page.MenuId}}" 
              [disabled]="(page.MenuId == 14 || page.MenuId == 15 || page.MenuId == 13)">
    
              </mat-checkbox>
            </td>
    
            <td class="mat-cell cdk-column-position mat-column-page" fxLayoutAlign="space-between center">
              <mat-checkbox class="mat-can-edit" aria-label="Can Edit" (change)="change($event,page)" 
              [(ngModel)]="page.CanUpdate" id="edit-{{page.MenuId}}" 
              [disabled]="(page.MenuId == 15)">
    
              </mat-checkbox>
            </td>
    
            <td class="mat-cell cdk-column-position mat-column-page" fxLayoutAlign="space-between center">
              <mat-checkbox lass="mat-can-delete" aria-label="Can Delete" (change)="change($event,page)" 
              [(ngModel)]="page.CanDelete" id="delete-{{page.MenuId}}" 
              [disabled]="(page.MenuId == 14 || page.MenuId == 15)">
    
              </mat-checkbox>
            </td>

            <td class="mat-cell cdk-column-position mat-column-page" fxLayoutAlign="space-between center">
                <mat-checkbox class="mat-can-map" aria-label="Can Map" (change)="change($event,page)"
                 [(ngModel)]="page.CanMap" id="map-{{page.MenuId}}" 
                 [disabled]="(page.MenuId == 14 || page.MenuId == 5)">
      
                </mat-checkbox>
              </td>
    
              <td class="mat-cell cdk-column-position mat-column-page" fxLayoutAlign="space-between center">
                <mat-checkbox class="mat-can-view-detail" aria-label="Can View Details" (change)="change($event,page)"
                 [(ngModel)]="page.CanViewDetail" id="view-detail-{{page.MenuId}}" 
                 [disabled]="!(page.MenuId == 14)">
      
                </mat-checkbox>
              </td>
    
          </tr>
        </tbody>
      </table>
  </div>
  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
      <button mat-raised-button color="accent" aria-label="SAVE" fxFlex="47" (click)="save();" >
          {{translations.btnSave}}
      </button>
      <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
          {{translations.btnClose}}
      </button>
  </div>
</div>     


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/page-access-edit-form/page-access-edit-form.component.html